import { render, staticRenderFns } from "./release-notes.vue?vue&type=template&id=108afbb0"
import script from "./release-notes.vue?vue&type=script&lang=ts"
export * from "./release-notes.vue?vue&type=script&lang=ts"
import style0 from "./release-notes.vue?vue&type=style&index=0&id=108afbb0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('108afbb0')) {
      api.createRecord('108afbb0', component.options)
    } else {
      api.reload('108afbb0', component.options)
    }
    module.hot.accept("./release-notes.vue?vue&type=template&id=108afbb0", function () {
      api.rerender('108afbb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/release-notes/release-notes.vue"
export default component.exports